import { GetUserSettings } from './getterTypes'

const getters = {
  [GetUserSettings](state) {
    return state.settings
  }
}

export default getters
